import {
  DialogContent as MuiDialogContent,
  DialogContentProps as MuiDialogContentProps,
} from '@mui/material';

export type ModalContentProps = MuiDialogContentProps;

export const ModalContent = (props: ModalContentProps) => <MuiDialogContent {...props} />;
